import { Button, Form, Input, Popconfirm, Table } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import shortid from 'shortid';

import './Common.css'

const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};
const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
}) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
    }, [editing]);
    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };
    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({
                ...record,
                ...values,
            });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };
    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: true,
                        message: `${title} is required.`,
                    },
                ]}
            >
                <Input ref={inputRef} onPressEnter={save} onBlur={save} />
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
};



const GlLineSelectionTable = (props) => {
    const [dataSource, setDataSource] = useState(props.dataSource);
    const [count, setCount] = useState(props.dataSource ? props.dataSource.length : 0);

    const handleDelete = (key) => {
        const newData = dataSource.filter((item) => item.key !== key);
        setDataSource(newData);
        props.setItems(newData)
    };

    let dataSourceForKey = dataSource.forEach(function (entry) {
        entry.key = shortid.generate();
    })

    const defaultColumns = [
        {
            title: 'id',
            dataIndex: 'id',
            width: '0%',
            editable: true,
            hidden: true
        },
        {
            title: 'name',
            dataIndex: 'name',
            width: '90%',
            editable: true,
        },
        {
            title: 'operation',
            dataIndex: 'operation',
            render: (_, record) =>
                dataSource.length >= 1 ? (
                    <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
                        <Button danger icon={<DeleteOutlined />}
                            size="small"
                            style={{ marginLeft: 16 }}
                        // onClick={onOk}
                        >
                        </Button>
                    </Popconfirm>
                ) : null,
        },
    ].filter(item => !item.hidden);;
    const handleAdd = () => {
        const newData = {
            key: count,
            name: `Neue linie`,

        };
        setDataSource([...dataSource, newData]);
        setCount(count + 1);
    };
    const handleSave = (row) => {
        const newData = [...dataSource];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });

        setDataSource(newData);
        props.setItems(newData)
    };
    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };
    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });
    return (
        <div>
            <Button
                onClick={handleAdd}
                style={{
                    marginBottom: 16,
                }}
            >
                <b>+</b>
            </Button>
            <Table
                components={components}
                rowClassName={() => 'editable-row'}
                bordered
                size='small'
                dataSource={dataSource}
                columns={columns}
                showHeader={false}
                pagination={false}
            />
        </div>
    );
};
export default GlLineSelectionTable;